import { Link } from 'react-router-dom';
import { yScrollContext } from '../restoreScroll/yScroll';
import { useContext } from 'react';

export const isExternalUrl = (url, infoJson, extraDomains = []) => {
  if (typeof url !== 'string') return false;
  if (url.startsWith('http://') || url.startsWith('https://')) return true;
  if (infoJson?.Noticias?.externas === true) return true;
  const domains = ['carmine', 'guiadoautomovel.pt', 'wpcomstaging.com', ...extraDomains];
  return domains.some(domain => url.includes(domain));
};

export const NewLinkNoticias = ({ location, infoJson, children }) => {
  const { yScroll } = useContext(yScrollContext);
  const isExternal = isExternalUrl(location, infoJson);

  return isExternal ? (
    <a
      href={location}
      aria-label="Ver notícia completa"
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  ) : (
    <Link
      aria-label="Ver notícia completa"
      to={location}
      state={{
        backward: {
          yscroll: yScroll,
        },
      }}
    >
      {children}
    </Link>
  );
};

export const NewLinkServicos = ({ location, externas, children }) => {
  if (!location) return children;
  return externas ? (
    <a href={location} aria-label="Link para serviço" target="_blank" rel="noreferrer">
      {children}
    </a>
  ) : (
    <Link aria-label="Link para serviço" to={location}>
      {children}
    </Link>
  );
};